import { FormattedMessage } from 'react-intl';

import { titles } from './constants';
import FormField from '../../components/FormField';
import messages from '../PersonalInformation/PersonalInformation.messages';
import { FieldWrapper } from '../PersonalInformation/types/PersonalInformation.types';

type NameQuestionProps = {
    titleField: FieldWrapper<string>;
    firstNameField: FieldWrapper<string>;
    lastNameField: FieldWrapper<string>;
};

export const NameQuestion = ({
    titleField,
    firstNameField,
    lastNameField
}: NameQuestionProps) => {
    const generateMultiFormFields = () => {
        return [
            {
                type: 'select',
                field: titleField,
                className: 'border-right fs-exclude',
                selectAttributes: {
                    value: titleField.value,
                    onChange: handleTitleSelect,
                    options: titles,
                    placeholder: 'Anrede'
                }
            },
            {
                field: firstNameField,
                type: 'input',
                className: 'border-right fs-exclude',
                inputAttributes: {
                    placeholder: 'Vorname',
                    maxLength: 100
                }
            },
            {
                field: lastNameField,
                type: 'input',
                className: 'fs-exclude',
                inputAttributes: {
                    placeholder: 'Nachname',
                    maxLength: 100
                }
            }
        ];
    };

    const handleTitleSelect = (title: FieldWrapper<string>) => {
        if (!title) return;

        titleField.onChange?.(title.value);
    };

    const fields = generateMultiFormFields();
    return (
        <FormField.Multiple
            label={<FormattedMessage {...messages.fullName} />}
            fields={fields}
        />
    );
};

export default NameQuestion;
